import React from 'react';
import { Link } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas'
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaPhone, FaEnvelope } from "react-icons/fa";
import Logo from '../../elements/logo/Logo';


const OffcanvasMenu = ({offcanvasShow, offcanvasHide}) => {
    
    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            // Calculer la position avec un offset de -80px pour le header fixe
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 80;
            
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
            
            offcanvasHide(); // Fermer le menu après le clic
        }
    };

    return (
        <Offcanvas 
            show={offcanvasShow} 
            onHide={offcanvasHide} 
            placement="end" 
            className="header-offcanvasmenu"
            backdrop={true}
            scroll={false}
        >
            <Offcanvas.Header closeButton>
                <Logo limage="/images/logos/test4.png" 
                    dimage="/images/logos/test4.png" 
                    simage="/images/logos/test4.png" />
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="row">
                    <div className="col-12">
                        <ul className="main-navigation list-unstyled">
                            
                            <li>
                                <a href="#accueil" onClick={(e) => { e.preventDefault(); scrollToSection('accueil'); }}>
                                    Accueil
                                </a>
                            </li>
                            <li>
                                <a href="#comment-ca-marche" onClick={(e) => { e.preventDefault(); scrollToSection('comment-ca-marche'); }}>
                                    Comment ça marche
                                </a>
                            </li>
                            <li>
                                <a href="#qui-sont-nos-locataires" onClick={(e) => { e.preventDefault(); scrollToSection('qui-sont-nos-locataires'); }}>
                                    Qui sont nos locataires
                                </a>
                            </li>
                            <li>
                                <a href="#blog" onClick={(e) => { e.preventDefault(); scrollToSection('blog'); }}>
                                    Blog
                                </a>
                            </li>
                            <li>
                                <a href="#faq" onClick={(e) => { e.preventDefault(); scrollToSection('faq'); }}>
                                    FAQ
                                </a>
                            </li>
                            <li>
                                <a href="#estimation" onClick={(e) => { e.preventDefault(); scrollToSection('estimation'); }}>
                                    Estimation gratuite
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-12">
                        <div className="contact-info-wrap">
                            <div className="contact-inner">
                                <address className="address">
                                    <span className="title">Contact</span>
                                    <a href="tel:+33123456789" className="tel"><FaPhone /> +33 1 23 45 67 89</a>
                                    <a href="mailto:contact@iso-eco.fr" className="tel"><FaEnvelope /> contact@iso-eco.fr</a>
                                </address>
                            </div>
                            <div className="contact-inner">
                                <h5 className="title">Suivez-nous</h5>
                                <div className="contact-social-share">
                                    <ul className="social-share list-unstyled">
                                        <li>
                                            <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
                                        </li>
                                        <li>
                                            <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
                                        </li>
                                        <li>
                                            <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default OffcanvasMenu;
